import React, { FC, useState } from "react";

interface DropdownPeer {
  question: string;
  answer: string;
  orderInList?: number; // kalau ini 0, rounded atas, kalau 1, rounded bawah. angka lain nggak rounded
}

export const DropdownFaq: FC<DropdownPeer> = ({ question, answer, orderInList }) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="flex justify-center items-center">
      <div className="relative w-10/12 overflow-hidden">
        <input
          type="checkbox"
          className="peer absolute top-0 inset-x-0 w-full h-full opacity-0 z-10 cursor-pointer"
          onChange={(e) => setIsChecked(e.target.checked)}
        />

        <div
          className={` bg-accent-100 w-full pl-14 pr-5 py-4 flex items-center 
            ${
              orderInList == 0
                ? "rounded-t-2xl"
                : orderInList == 1 && isChecked == false
                ? "rounded-b-2xl transition-all duration-500 delay-300"
                : isChecked == true
                ? "transition-all duration-200"
                : ""
            }
          `}
        >
          <h1 className="text-white font-normal font-sans text-lg">{question}</h1>
        </div>

        <div className="absolute top-5 left-3 text-secondary-100 transition-transform duration-500 rotate-0 peer-checked:rotate-180">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 15l-6-6-6 6" />
          </svg>
        </div>

        {/* Jawaban */}
        <div className="bg-white overflow-hidden transition-all duration-500 max-h-0 peer-checked:max-h-60">
          <div className="flex pl-14 pr-5 py-4">
            <p className="text-sm text-secondary-100 font-body font-normal">
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
